<template >
  <div>
    <!-- <iframe width="100%" :height="height" frameborder="0" src="http://10.0.4.16:8080/webroot/decision/view/form?viewlet=EAM%252FjiangsuFault1.frm"></iframe> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: document.documentElement.clientHeight - 140 + 'px'
    }
  },
  computed: {
    currentIndexBranch() {
      return this.$store.state.currentIndexBranch
    },
    //是否刷新数据
    updateMainTableData() {
      return this.$store.state.updateMainTableData
    },
    //当前左侧菜单选中的信息
    currentSelectMenuData() {
      return this.$store.state.currentSelectMenuData
    },
  },
  watch: {
    // 监听路由变化 （切换应用时重新请求json、清空子表布局信息等操作）
    '$route': function () {
      this.openUrl();
    },
    //监听是否需要刷新列表数据
    updateMainTableData(val) {
      if (val) {
        this.openUrl()
      }
    }
  },
  methods: {
    openUrl() {
      this.$store.commit("setupdateMainTableData", false)
      if (!!this.currentSelectMenuData.path) {
        var url = this.currentSelectMenuData.path.replace(':branch', this.currentIndexBranch)
        window.open(url)
      }
    }
  },
  mounted() {
    this.openUrl();
  }
}
</script>


